import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { BrowserRouter } from "react-router-dom";
import { UserProvider } from "./model/contexts/user.context";
import { ProjectProvider } from "./model/contexts/project.context";
import { TaskProvider } from "./model/contexts/task.context";
import { NoteProvider } from "./model/contexts/note.context";
import { TemplateProvider } from "./model/contexts/template.context";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <UserProvider>
        <ProjectProvider>
          <TemplateProvider>
            <TaskProvider>
              <NoteProvider>
                <App />
              </NoteProvider>
            </TaskProvider>
          </TemplateProvider>
        </ProjectProvider>
      </UserProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
